
import { X } from "lucide-react";
import { Guest } from "../types/guest";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";

interface GuestPreviewListProps {
  guests: Guest[];
  onRemoveGuest: (index: number) => void;
}

export const GuestPreviewList = ({ guests, onRemoveGuest }: GuestPreviewListProps) => {
  if (guests.length === 0) return null;

  const getInitials = (firstName: string = '', lastName: string = '') => {
    return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase() || 'G';
  };

  return (
    <div className="space-y-2">
      {guests.map((guest, index) => (
        <div 
          key={index}
          className="flex items-center justify-between p-3 bg-gray-50 rounded-lg"
        >
          <div className="flex items-center gap-3">
            <Avatar className="h-8 w-8 bg-white text-black border-2 border-black">
              <AvatarFallback className="text-sm font-medium">
                {getInitials(guest.firstName, guest.lastName)}
              </AvatarFallback>
            </Avatar>
            <div>
              <p className="font-medium">
                {guest.firstName} {guest.lastName}
              </p>
              {guest.phoneNumber && (
                <p className="text-sm text-gray-500">{guest.phoneNumber}</p>
              )}
            </div>
          </div>
          <button
            onClick={() => onRemoveGuest(index)}
            className="p-1 hover:bg-gray-200 rounded-full transition-colors"
            type="button"
          >
            <X className="h-4 w-4 text-gray-500" />
          </button>
        </div>
      ))}
    </div>
  );
};
